import { useNavigate, useParams } from "react-router-dom";
import IssueComments from "./IssueComments";
import IssueTask from "./IssueTask";
import IssueLogHours from "./IssueLogHour";
import IssueDocument from "./IssueDocument";
import IssueActivityStream from "./IssueActivity";
import { useFetchGetAllProjectBasedUserNameListQuery, useFetchIssueDetailViewQuery, useFetchIssueModuleQuery} from "../../../slice/logdetailSlice";
import { CommonIssueDetail } from "../../common/Issue/CommonIssueDetail";


export const IssueTabs = ({
  issue_id,
  document_count,
  comment_count,
  assignee_name,
  added_by,
  login_user_name,
  login_user_id,
  login_user_role,
  logHours,
}) => {
  //console.log(
  //   "login_users_",
  //   login_user_name,
  //   assignee_name,
  //   login_user_id,
  //   added_by
  // );

  return (
    <div className="mt-3 ">
      <ul className="nav nav-tabs" id="myTab" role="tablist">
        <li className="nav-item pe-4" role="presentation">
          <button
            className=" active text-rgba-gray R_btn"
            id="Comments-tab"
            data-bs-toggle="tab"
            data-bs-target="#Comments"
            type="button"
            role="tab"
            aria-controls="Comments"
            aria-selected="true"
          >
            Comments ({comment_count})
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="Subtasks-tab"
            data-bs-toggle="tab"
            data-bs-target="#Subtasks"
            type="button"
            role="tab"
            aria-controls="Subtasks"
            aria-selected="false"
          >
            Tasks
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          {(["ADMIN", "MANAGER"].includes(login_user_role) || // ✅ Allow Admin & Manager
            login_user_name === assignee_name ||
            login_user_id === added_by) && (
            <button
              className=" text-rgba-gray R_btn"
              id="LogHours-tab"
              data-bs-toggle="tab"
              data-bs-target="#LogHours"
              type="button"
              role="tab"
              aria-controls="LogHours"
              aria-selected="false"
            >
              {/* Log Hours */}
              Log Hours ({logHours || "00:00"})
            </button>
          )}
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="Documents-tab"
            data-bs-toggle="tab"
            data-bs-target="#Documents"
            type="button"
            role="tab"
            aria-controls="Documents"
            aria-selected="false"
          >
            Attachment ({document_count})
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="ActivityStream-tab"
            data-bs-toggle="tab"
            data-bs-target="#ActivityStream"
            type="button"
            role="tab"
            aria-controls="ActivityStream"
            aria-selected="false"
          >
            Activity Stream
          </button>
        </li>
      </ul>

      <div className="tab-content" id="myTabContent">
        <div
          className="tab-pane fade show active"
          id="Comments"
          role="tabpanel"
          aria-labelledby="Comments-tab"
        >
          <IssueComments issue_id={issue_id} />
        </div>

        <div
          className="tab-pane fade"
          id="Subtasks"
          role="tabpanel"
          aria-labelledby="Subtasks-tab"
        >
          <IssueTask />
        </div>

        <div
          className="tab-pane fade"
          id="LogHours"
          role="tabpanel"
          aria-labelledby="LogHours-tab"
        >
          <IssueLogHours />
        </div>

        <div
          className="tab-pane fade"
          id="Documents"
          role="tabpanel"
          aria-labelledby="Documents-tab"
        >
          <IssueDocument issue_id={issue_id} />
        </div>

        <div
          className="tab-pane fade"
          id="ActivityStream"
          role="tabpanel"
          aria-labelledby="ActivityStream-tab"
        >
          <IssueActivityStream />
        </div>
      </div>
    </div>
  );
};

const IssueDetail = () => {
  const { id } = useParams();
  const { project_id } = useParams();
  //console.log("project_id_in_detail :", project_id, id);
  const navigate = useNavigate();
  const { refetch: issue_module_refetch } = useFetchIssueModuleQuery()
  const { data: project_based_users } = useFetchGetAllProjectBasedUserNameListQuery(project_id);
  const { refetch } = useFetchIssueDetailViewQuery(id);
  // Status option from redux
  const handleBoxClick = (issue_id) => {
    // Reset the state before navigating
  navigate(`/projects/projectDetail/${project_id}/issue/IssueDetail/${issue_id}`,);
  };

  return (
    <>
      <CommonIssueDetail
        showpath="issue/show"
        updatePath="issue/update"
        project_id={project_id}
        id={id}
        project_based_users={project_based_users}
        issue_detail_refetch={refetch}
        issue_module_refetch={issue_module_refetch}
        handleBoxClick={handleBoxClick}
        isIssueDetail={true}
      />
    </>
  );
};

export default IssueDetail;
